import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {Messages} from "../../../Messages";
import {UserPreferencesStore} from "../../../State";
import {MerchantCard, MerchantCardStyle} from "../../ui/MerchantCard";
import {BlinkButton} from "../../../ui/Button.jsx";
import {ExternalLink} from "../../ui/ExternalLink";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {MerchantPopup} from "../../ui/MerchantPopup";
import {Money} from "../../../../client/state/misc/Money";
import {userService} from "../../../../client/connection/Services";
import {WalletStore} from "../../../State";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {MessageElement} from "../../ui/MessageElement";
import {apiUpdateUserMerchantPreferences, MerchantUserStore} from "../../../../client/state/merchant/MerchantUserStore";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw.js";


class AutopayCardStyle extends MerchantCardStyle {
    @styleRule
    infoLine = {
        marginBottom: 14,
    };
}


@registerStyle(AutopayCardStyle)
@autoredraw(UserPreferencesStore, MerchantUserStore)
class AutopayCard extends MerchantCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.manageAutopay,
        };
    }

    isAutopayDefaultDisabled() {
        return !UserPreferencesStore.getPreferences().autoPayEnabled;
    }

    render() {
        const {styleSheet} = this;
        const articlePriceLimit = new Money(
            UserPreferencesStore.getPreferences().articlePriceLimit,
            WalletStore.getWallet().getCurrency()
        );
        const disabled = this.isAutopayDefaultDisabled();

        return [
            <MessageElement
                className={styleSheet.infoLine}
                message={disabled ? Messages.disabledAutopayInfo1
                    : Messages.autopayInfo1(iFrameMerchantService.getMerchant().getName(), articlePriceLimit)}/>,
            <div className={styleSheet.infoLine}>
                {disabled ? Messages.disabledAutopayInfo2 : Messages.autopayInfo2}
                <ExternalLink label={Messages.blinkDashboard} href="/"/>.
            </div>,
        ];
    }

    renderPrimaryButton() {
        return <BlinkButton
            label={iFrameUserDataService.isAutoPayEnabled() ? Messages.disableAutopay : Messages.enableAutopay}
            onClick={() => this.toggleAutopay()}
            disabled={this.isAutopayDefaultDisabled()}
        />;
    }

    @wrapInSpinner
    async toggleAutopay() {
        const merchant = iFrameMerchantService.getMerchant();
        await apiUpdateUserMerchantPreferences({
            userId: userService.getUserId(),
            merchantId: merchant.id,
            autoPayEnabled: !iFrameUserDataService.isAutoPayEnabled(),
        });
    }
}

export const Autopay = MerchantPopup(AutopayCard);
